import { useEffect, useRef } from "react";

export default function Schedule() {
  const widgetContainerRef = useRef(null);

  useEffect(() => {
    const container = widgetContainerRef.current;
    if (!container) return;
    if (container.querySelector(".mindbody-widget")) return;

    const widgetDiv = document.createElement("div");
    widgetDiv.className = "mindbody-widget";
    widgetDiv.setAttribute("data-widget-type", "Schedules");
    widgetDiv.setAttribute("data-widget-id", "24485199377");
    container.appendChild(widgetDiv);

    if (!document.querySelector('script[src="https://brandedweb.mindbodyonline.com/embed/widget.js"]')) {
      const script = document.createElement("script");
      script.src = "https://brandedweb.mindbodyonline.com/embed/widget.js";
      script.async = true;
      document.body.appendChild(script);
    }

    return () => {
      while (container.firstChild) container.removeChild(container.firstChild);
    };
  }, []);

  return (
    <div data-testid="member-schedule-page">
      <h2 className="text-2xl font-light text-[#E8DCC4] mb-2">Class Schedule</h2>
      <p className="text-[#E8DCC4]/60 text-sm mb-5">Browse upcoming classes and book your spot.</p>
      <div ref={widgetContainerRef} className="bg-white rounded-2xl overflow-hidden p-1" data-testid="mindbody-widget-container" />
      <p className="text-[#E8DCC4]/40 text-xs text-center mt-4">Powered by MindBody · Bookings sync to your MindBody account.</p>
    </div>
  );
}
